var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center overflow-auto"},[(_vm.fileReady)?_c('img',{style:({
      'max-width': _vm.$store.state.app.isMobile ? '100% !important' : 'inherit'
    }),attrs:{"src":((_vm.file.link) + "?w=1200")}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }